const { getCurrentTenant } = require('@vp/tenant-resolution');

function getAttribute() {
    return getCurrentTenant();
}
module.exports = { getAttribute };
